import React from "react";
import { Alert, Button, Card, TextField, Typography } from "@mui/material";

import UnauthNav from "../../components/UnauthNav/UnauthNav";
import ManagerForgotPasswordDialog from "../../components/ManagerForgotPasswordDialog/ManagerForgotPasswordDialog";

import "./ManagerLoginView.scss";
import { Login } from "@mui/icons-material";
import AuthApi from "../../api/AuthApi";
import { consumeSessionExpiredFlag } from "../../utils/sessionGuard";
const ManagerLoginView = () => {

  const [username, setUsername] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [error, setError] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(false);
  const [forgotPasswordOpen, setForgotPasswordOpen] = React.useState(false);
  // True when the session guard sent us here, so the redirect is explained rather than mysterious.
  const [sessionExpired] = React.useState(() => consumeSessionExpiredFlag());

  const loginReq = () => {
    setIsLoading(true);
    setError(false);
    
    AuthApi.managerLogin({
      Manager_Username: username,
      Manager_Password: password
    }).then((user) => {
      console.log("Login successful", user);
      // Handle successful login, e.g., redirect to dashboard
      setTimeout(()=>{
        window.location.href = "/home";
      }, 1000)
      
    }).catch((error) => {
      console.error("Login failed", error);
      setError(true);
      setIsLoading(false);
      // Handle login failure, e.g., show an error message
    });
  }

  return (
    <>
      <UnauthNav />
      <div className="manlv">
        <Card className="manlv-card">
          <Typography variant="h1" className="manlv-card-ttl">Manager Login</Typography>
          {sessionExpired && (
            <Alert severity="info">
              Your session has expired. Please sign in again to continue — nothing has been lost.
            </Alert>
          )}
          <TextField
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            label="Username" 
            variant="outlined"
            disabled={isLoading}
          />
          <TextField
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            label="Password"
            variant="outlined"
            type="password"
            disabled={isLoading}
          />
          {error && (
            <Typography variant="body2" color="error" className="manlv-card-err">Invalid username or password</Typography>
          )}
          <Button 
            onClick={loginReq} 
            variant="contained" 
            color="primary"
            disabled={isLoading}
          >
            {isLoading ? "Logging in..." : "Login"}
          </Button>
          <Button
            onClick={() => setForgotPasswordOpen(true)}
            variant="text"
            color="secondary"
            disabled={isLoading}
          >
            Forgot Password
          </Button>
        </Card>

        <ManagerForgotPasswordDialog
          open={forgotPasswordOpen}
          onClose={() => setForgotPasswordOpen(false)}
        />
      </div>
    </>
  );
}
export default ManagerLoginView;